import { Pipe, PipeTransform } from '@angular/core';

type Value = boolean | string | [];
type FilterDataType = Record<string, Value>;

const hasChildren = (arr: any[]) => arr.filter(Boolean).length > 0;
const hasValue = (value: Value) => {
  if (Array.isArray(value)) {
    return hasChildren(value);
  }

  if (typeof value === 'boolean') {
    return true;
  }

  return !!value;
};

@Pipe({
  name: 'isPopulatedFilter'
})
export class IsPopulatedFilterPipe implements PipeTransform {
  transform(data: FilterDataType): boolean {
    return Object.values(data).some(hasValue);
  }
}
